var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81423 8.81276C8.57989 9.04717 8.44824 9.36506 8.44824 9.69651C8.44824 10.028 8.57989 10.3459 8.81423 10.5803L13.2342 15.0003L8.81423 19.4203C8.69484 19.5356 8.59961 19.6735 8.5341 19.826C8.46859 19.9785 8.43411 20.1425 8.43266 20.3085C8.43122 20.4745 8.46285 20.6391 8.5257 20.7927C8.58855 20.9463 8.68137 21.0859 8.79873 21.2033C8.9161 21.3206 9.05566 21.4134 9.20928 21.4763C9.36291 21.5391 9.5275 21.5708 9.69348 21.5693C9.85945 21.5679 10.0235 21.5334 10.176 21.4679C10.3285 21.4024 10.4664 21.3071 10.5817 21.1878L15.0017 16.7678L19.4217 21.1878C19.6575 21.4155 19.9732 21.5415 20.301 21.5386C20.6287 21.5358 20.9422 21.4043 21.174 21.1725C21.4058 20.9408 21.5372 20.6273 21.5401 20.2995C21.5429 19.9718 21.4169 19.656 21.1892 19.4203L16.7692 15.0003L21.1892 10.5803C21.4169 10.3445 21.5429 10.0288 21.5401 9.70101C21.5372 9.37326 21.4058 9.05975 21.174 8.82799C20.9422 8.59623 20.6287 8.46477 20.301 8.46192C19.9732 8.45907 19.6575 8.58506 19.4217 8.81276L15.0017 13.2328L10.5817 8.81276C10.3473 8.57842 10.0294 8.44678 9.69798 8.44678C9.36652 8.44678 9.04864 8.57842 8.81423 8.81276Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6fac95883484442250643410c5423030.svg";
export { ForwardRef as ReactComponent };